import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { IGetServiceProps } from "@api/types/globalService.types";

export const useGetAllThemeServices = ({
  page = "1",
  per_page = "15",
  enableQuery,
  showActiveOnly = true,
}: IGetServiceProps) => {
  const allThemeService = useQuery({
    queryKey: [...CACHE_KEYS.THEMES, page, per_page, showActiveOnly],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.THEMES,
        searchParams: {
          page,
          per_page,
        },
      }),
    enabled: enableQuery,
  });

  return { services: { allThemeService } };
};
